import '~/init';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {Route, RouterProvider, createHashRouter, createRoutesFromElements} from 'react-router-dom';
import {PersistGate} from 'redux-persist/lib/integration/react';
import init from './state/store';
import './resources';
import AppInit from '~/app-init';
import AuthWrapper from "~/AuthWrapper";
import routes from '~/route-map'
import {isOidcCallbackStillInUrl} from "~/utils/url-utils";
import {APIKEY_HASH_RE, POST_LOGIN_REDIRECT_APIKEY_HASH} from "~/constants";

const {store, persistor} = init();

(function captureApiKeyDeepLinkAtBoot() {
    const {hash = "", search = ""} = window.location;
    const isOidcCallback = isOidcCallbackStillInUrl(search)
    const isApiKeyDeepLink = APIKEY_HASH_RE.test(hash);
    const existingHash: string | null = sessionStorage.getItem(POST_LOGIN_REDIRECT_APIKEY_HASH);

    if (!isOidcCallback && isApiKeyDeepLink && !existingHash) {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_APIKEY_HASH, hash);
    }
})();

const router = createHashRouter(
    createRoutesFromElements(
        <Route
            path={routes.any}
            element={(
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <AppInit>
                            <AuthWrapper/>
                        </AppInit>
                    </PersistGate>
                </Provider>
            )}
        />  
    )
);

const container = document.getElementById('app-container');
const root = createRoot(container);
root.render(<RouterProvider router={router} />);